<template>
  <div class="help-page">
    <el-table
      :data="qualification"
      :span-method="spanMethod"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        prop="firstLevel"
        label="一级类目"
        width="180"
      />
      <el-table-column
        prop="secondLevel"
        label="二级类目"
        width="240"
      />
      <el-table-column
        prop="desc"
        label="资质说明"
      />
    </el-table>
  </div>
</template>

<script>
import qualification from '@/common/qualification';

export default {
  data: () => ({
    qualification: qualification.data,
    formatList: [],
  }),
  created() {
    this.formatList = this.splitData();
  },
  methods: {
    splitData() {
      let result = [];
      const res = this.qualification.reduce(
        (r, v, i) => {
          let isSame =
            v['firstLevel'] === (this.qualification[i + 1] || {})['firstLevel'];
          if (isSame) {
            r[r.length - 1] = r[r.length - 1] + 1;
          } else {
            r.push(1);
          }

          return r;
        },
        [1],
      );

      // 删除余项
      res.pop();
      res.forEach((i) => {
        result = [...result, i, ...Array(i - 1).fill(0)];
      });

      return result;
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: this.formatList[rowIndex],
          colspan: this.formatList[rowIndex] > 0 ? 1 : 0,
        };
      }
    },
  },
};
</script>
